<p-button pRipple *ngIf="allowSubmit && !readOnly" styleClass="float-button-2 p-button-raised p-button-success m-2" (click)="submitApplication()" [disabled]="application?.partnerApplicationStatus" >
    <ng-template pTemplate="content">
        <div class="d-flex justify-content-center">
            <fa-icon [icon]='["far","check-double"]' size="lg" class="ms-1 me-2"></fa-icon>
            {{applicationSubmitButtonLabel}}
        </div>
    </ng-template>
</p-button>
<p-button pRipple *ngIf="allowSave && !readOnly" styleClass="float-button-1 p-button-raised p-button-info m-2" (click)="saveApplication()">
    <ng-template pTemplate="content">
        <div class="d-flex justify-content-center">
            <fa-icon [icon]='["far","save"]' size="lg" class="mx-2"></fa-icon>
            Save
        </div>
    </ng-template>
</p-button>

<ng-container *ngIf="comingSoon">
    <div class="d-flex justify-content-center">
        <div>
            <!-- <img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-logo.png" alt="FocusPay Payments Logo"> -->
            <img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-logo-coming-soon.png"
                alt="FocusPay Payments Coming Soon!">
        </div>
    </div>
    <div class="d-flex justify-content-center">
        <div class="h3"><i>Focused on your success!</i></div>
    </div>
</ng-container>

<div #applicationFields *ngIf="!comingSoon" class="d-flex justify-content-center">

    <div #parentContainer style="max-width: 1200px;">

        <div class="d-flex flex-wrap justify-content-center">
            <div class="d-flex justify-content-center">
                <img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-logo.png"
                    alt="FocusPay Payments Logo">
            </div>
            <div class="d-flex justify-content-center">
                <img *ngIf="application.dealerKey"
                    src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/{{application.dealerKey}}-fpapplogo.png"
                    width="300" height='auto' alt="Dealer logo">
            </div>
        </div>
        <div class="d-flex card mx-4 my-2">
            <div class="d-flex flex-column">
                <div class="m-2 text-center">
                    Welcome to FocusPay, the fully integrated payment solution for your restaurant.
                </div>
                <div class="m-2 text-center">
                    We appreciate you taking the time to complete the application below. If at any point you need to
                    save
                    your progress, just hit the blue save button.
                </div>
            </div>

            <app-application-restaurant-information #restaurant [(application)]="application"  [readOnly]="readOnly" (inputAction)="inputAction($event)" (displayModal)="'displayModal = $event'"></app-application-restaurant-information>
            <app-application-legal-information #legal [(application)]="application"  [readOnly]="readOnly" (inputActionEmitter)="inputAction($event)" (displayModal)="'displayModal = $event'"></app-application-legal-information>
            <app-application-business-info #business [(application)]="application"  [readOnly]="readOnly" (inputActionEmitter)="inputAction($event)" (displayModal)="'displayModal = $event'"></app-application-business-info>
            <app-application-banking-information #banking [(merchantBanking)]="application.merchantBanking"  [readOnly]="readOnly" (displayModal)="displayModal = $event" (inputActionEmitter)="inputAction($event)"></app-application-banking-information>
            <app-application-merchant-contact #owner [(merchantContacts)]="application.merchantContacts"  [readOnly]="readOnly" (displayModal)="displayModal = $event" (inputActionEmitter)="inputAction($event)"></app-application-merchant-contact>
            <app-application-payment-service-rates [(processingRates)]="application.processingRates"  (displayModal)="displayModal = $event"></app-application-payment-service-rates>
            <app-application-terms-and-conditions (displayModal)="displayModal = $event"></app-application-terms-and-conditions>

            <app-application-submitted-successfully [visible]="applicationSubmittedSuccessfully" [applicationId]="application.sk"></app-application-submitted-successfully>
        </div>
            <div class="d-flex justify-content-center">
                <app-terms-of-service-footer></app-terms-of-service-footer>
            </div>
    </div>

</div>


<app-application-help [(displayModal)]="displayModal"></app-application-help>